import httpService from '../Api/http.service';
import { buildQuery, getApiBaseUrl } from 'utils';

const getSSOBaseUrl = () => `${getApiBaseUrl()}/appcore/sso`;
const getAuthMethodsBaseUrl = () => `${getApiBaseUrl()}/appcore/auth/methods`;

// SSO Config Management

const getSSOConfigs = (level, levelId, ssoProvider) => {
  const query = buildQuery({
    level,
    level_id: levelId,
    ...(ssoProvider && { sso_provider: ssoProvider }),
  });

  return httpService({
    url: `${getSSOBaseUrl()}/configs${query}`,
    method: 'get',
  });
};

const createSSOConfig = (level, levelId, payload) => {
  const query = buildQuery({ level, level_id: levelId });

  return httpService({
    url: `${getSSOBaseUrl()}/configs${query}`,
    method: 'post',
    data: payload,
  });
};

const updateSSOConfig = (configId, payload) => {
  return httpService({
    url: `${getSSOBaseUrl()}/configs/${configId}`,
    method: 'put',
    data: payload,
  });
};

const activateSSOConfig = (configId, isActive) => {
  return httpService({
    url: `${getSSOBaseUrl()}/configs/${configId}/activate`,
    method: 'patch',
    data: { is_active: isActive },
  });
};

const deleteSSOConfig = (configId) => {
  return httpService({
    url: `${getSSOBaseUrl()}/configs/${configId}`,
    method: 'delete',
  });
};

// Auth Methods

const getAuthMethods = (level, levelId) => {
  const query = buildQuery({ level, level_id: levelId });

  return httpService({
    url: `${getAuthMethodsBaseUrl()}${query}`,
    method: 'get',
  });
};

const updateAuthMethods = (level, levelId, authMethods) => {
  const query = buildQuery({ level, level_id: levelId });

  return httpService({
    url: `${getAuthMethodsBaseUrl()}${query}`,
    method: 'put',
    data: { auth_methods: authMethods },
  });
};

// Group Mappings

const getGroupMappings = (level, levelId, ssoProvider) => {
  const query = buildQuery({ level, level_id: levelId, sso_provider: ssoProvider });

  return httpService({
    url: `${getSSOBaseUrl()}/group-mappings${query}`,
    method: 'get',
  });
};

const createGroupMapping = (level, levelId, ssoProvider, payload) => {
  const query = buildQuery({ level, level_id: levelId, sso_provider: ssoProvider });

  return httpService({
    url: `${getSSOBaseUrl()}/group-mappings${query}`,
    method: 'post',
    data: payload,
  });
};

const updateGroupMapping = (mappingId, payload) => {
  return httpService({
    url: `${getSSOBaseUrl()}/group-mappings/${mappingId}`,
    method: 'put',
    data: payload,
  });
};

const deleteGroupMapping = (mappingId) => {
  return httpService({
    url: `${getSSOBaseUrl()}/group-mappings/${mappingId}`,
    method: 'delete',
  });
};

const ssoService = {
  getSSOConfigs,
  createSSOConfig,
  updateSSOConfig,
  activateSSOConfig,
  deleteSSOConfig,
  getAuthMethods,
  updateAuthMethods,
  getGroupMappings,
  createGroupMapping,
  updateGroupMapping,
  deleteGroupMapping,
};

export default ssoService;
